import React, { FC, Fragment, memo } from 'react'

import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'

import { coreSelectors } from '@ucheba/store/core'

import { useSelector } from 'react-redux'
import { ICampus } from '../types'

import { Grid, Header, NotDescriptionText, NotDescription, Pin } from '../styles'

const InfrastructureList: FC<ICampus> = (props) => {
  const { campus } = props

  const isTouch = useSelector(coreSelectors.isTouch)

  // Одинаковые компоненты, поэтому выбор обёртки вынес сюда
  const Container = isTouch ? Fragment : Grid

  const isDescriptions = campus.find(({ description }) => !!description)

  return (
    <>
      {isDescriptions ? (
        <>
          <Spacing spacing='xlarge' />

          <Container>
            {campus.map(({ id, description, type, objects }) => (
              <div key={id}>
                <Header>
                  {!!objects?.length && <Pin color={type.color} />}

                  {type.name}
                </Header>

                <Spacing spacing='xxsmall' />

                <Text>{description}</Text>
              </div>
            ))}
          </Container>

          <Spacing spacing='xlarge' />
        </>
      ) : (
        <>
          <NotDescription>
            {campus.map(({ id, type, objects }) => (
              <NotDescriptionText key={id}>
                {!!objects?.length && <Pin color={type.color} />}

                {type.name}
              </NotDescriptionText>
            ))}
          </NotDescription>

          <Spacing spacing='large' />
        </>
      )}
    </>
  )
}

export default memo(InfrastructureList)
